import md5 from 'js-md5';
import sha1 from 'sha1';

import { getTridToken } from '@/api/user';
import Message from '@/components/message';
import { getCookie, setCookie } from '@/fe_modules/utils/cookie';
import { currEvn } from '@/utils/http_help';

import * as bom from '../fe_modules/utils/bom';

//路由钩子回跳URl
const loginBackurl = window.location.href;
let serviceUrl: string;
if (currEvn === 'dev') {
  serviceUrl = `http://passport.dev.iol8.net/login?service=${loginBackurl}`;
} else if (currEvn === 'test') {
  serviceUrl = `http://passport.qa.iol8.net/login?service=${loginBackurl}`;
} else if (currEvn === 'release') {
  serviceUrl = `http://passport.release.iol8.net/login?service=${loginBackurl}`;
} else {
  serviceUrl = `https://passport.iol8.com/login?service=${loginBackurl}`;
}
export const handleAuth = async (to: any, from: any, next: any) => {
  const ticket = bom.getQuery('ticket');
  const trId =
    decodeURI(getCookie(`woordee_${currEvn}_talent_login_user`))
      .split('|')
      .reverse()[0] || '';

  if (ticket) {
    try {
      const res = await getTridToken({ ticket });
      if (res.data?.code == 0) {
        WtCookie(res.data.token, res.data.connectId);
        removeURLParameter('ticket');
        // next();
      } else {
        console.log(res.data.message);
      }
    } catch (err: any) {
      console.log('err', err);
      Message.warn(err);
    }
  } else {
    if (!trId) {
      console.log('没有ticket,你还没登录');
      window.location.href = serviceUrl;
    } else {
      console.log('没有ticket,已经登录');
    }
  }
};

const WtCookie = (token: string, connectId: string) => {
  const sign = sha1(md5(connectId + md5(connectId) + 'E4&c3vE!vJxxqw1w'));
  const c_trid = `|${sign}|${connectId}`;
  const suffix = `.iol8.${currEvn === 'pro' ? 'com' : 'net'}`;
  setCookie(`woordee_${currEvn}_talent_login_user`, c_trid, suffix);
  setCookie(`woordee_${currEvn}_talent_login_token`, token, suffix);
};

export const removeURLParameter = (parameterName: string) => {
  const url = new URL(window.location.href);
  const searchParams = new URLSearchParams(url.search);
  // 删除指定的参数
  searchParams.delete(parameterName);
  // 构建新的URL
  url.search = searchParams.toString();
  window.location.href = url.toString();
  // 将新URL设置为浏览器地址栏中的URL，但不进行跳转。这里改了，不跳拿cookie有问题：onMounted和router.beforeEach的执行顺序是个谜
  // window.history.replaceState({}, document.title, url.toString());
};

// 在路由中使用
// import { handleAuth } from '@/utils/auth'; // 导入 auth 模块
// router.beforeEach((to, from, next) => {
//   handleAuth(to, from, next);
//   to.meta?.title && ((window as any).document.title = to.meta.title);
//   next();
//   document.body.scrollTop = 0;
//   // firefox
//   document.documentElement.scrollTop = 0;
// });
